import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import stripComments from './strip-comments';
import replaceEncodedCharacters from '../replace-encodings/replace-encodings';
import box from '../box/box';
export default (function (payload) {
  return new Promise(function (resolve, reject) {
    try {
      var result = box(payload).map(function (s) {
        return stripComments(s);
      }).map(function (s) {
        return replaceEncodedCharacters(s);
      }).fold(function (s) {
        return JSON.parse(s);
      });
      resolve(result);
    } catch (e) {
      // Check for empty response, as this is a valid condition (SelfPay cancel transfer response).
      if (!payload || 'OK' === payload || '' === payload) {
        resolve({});
        return;
      }

      if (payload.indexOf('screenid:session_timeout') > -1) {
        // TODO: Signal a session timeout. Needs to happen up the chain somewhere. Possibly by adding a
        // property to the FailureMessageBean
        reject({
          FailureMessageBean: {
            message: 'Session Timeout',
            level: 'SYSTEM_ERROR'
          }
        });
        return;
      } // TODO: Is this a network error? Need to life code from mwf-core-network


      reject({
        FailureMessageBean: {
          message: 'Error parsing JSON response',
          level: 'SYSTEM_ERROR'
        }
      });
    }
  });
});